/**
 *
 * @param {string} text a string that will be copied to clipboard
 */
const copyToClipboard = (text) => {
	navigator.clipboard.writeText(text);
};

export default copyToClipboard;
